import React from 'react';
import LoadStatus from '../../utilities/load-status';
import PropTypes from 'prop-types';

class Select extends React.Component {
  render() {
    const list = this.props.options.map((item, i) => {
      return (
        <option key={i} value={this.props.valueProperty ? this.props.valueProperty : item.value}>
          {this.props.displayProperty ? item[this.props.displayProperty] : item.display}
        </option>
      );
    });
    if (this.props.emptyValue) {
      list.unshift(
        <option key="default" disabled>
          {this.props.emptyValue}
        </option>
      );
    }
    return (
      <div className="dropdown-list" style={{ position: 'relative' }}>
        <select
          type="text"
          className="dropdown-list-select form-control"
          id={this.props.id}
          name={this.props.id}
          onChange={this.props.onChange}
          value={this.props.value}
          required={this.props.required}
          style={{ position: 'relative' }}
          disabled={this.props.disabled}
          multiple={this.props.multiselect}
        >
          {list}
        </select>
        {this.props.multiselect ? '' : (
          <div
            className="dropdown-list-icon text-center"
            style={{
              position: 'absolute',
              margin: 'auto',
              fontSize: '1.25em',
              height: '1.25em',
              width: '2em',
              top: '-0.4em', right: '0.5em', bottom: 0
            }}
          >
            {this.props.loading ? (
              <LoadStatus spins color="rgba(51, 51, 51, 0.5)" />
            ) : ''}
          </div>
        )}
        {!this.props.error ? '' : (
          <span className="text-left"><small>
            <strong>
              {this.props.error.code ? `Error (${this.props.error.code})`: ''}
              {this.props.error.origin ? <small>{this.props.error.origin}</small> : ''}
              {this.props.error.message || ''}
            </strong>
          </small></span>
        )}
      </div>
    );
  }
}

Select.propTypes = {
  options: PropTypes.array,
  emptyValue: PropTypes.string,
  valueProperty: PropTypes.string,
  displayProperty: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  error: PropTypes.object,
  multiselect: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool
};

Select.defaultProps = {
  options: [],
  multiselect: false,
  required: false,
  disabled: false,
  loading: false
};

export default Select;
